import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Button, SunIcon, MoonIcon } from "@cividao/components"
import { CredentialsStep } from "./CredentialsStep"
import { VerificationStep } from "./VerificationStep"
import styles from "./index.module.css"
import { LOGO_FULL_DARK_MODE } from "../../../js/const"
import { useLogos } from "../../../hooks/useLogos"
import { useLayout } from "../../../context/LayoutContext"
import { ThemeMode } from "../../../context/LayoutContext/types"

enum LoginStep {
  CREDENTIALS = "CREDENTIALS",
  VERIFICATION = "VERIFICATION",
}

export function LoginTemplate() {
  const { t } = useTranslation("auth")
  const { logoFull: mobileLogoSrc } = useLogos()
  const { themeMode, setThemeMode } = useLayout()
  const [currentStep, setCurrentStep] = useState<LoginStep>(LoginStep.CREDENTIALS)
  const [email, setEmail] = useState("")

  const handleCredentialsComplete = (userEmail: string) => {
    setEmail(userEmail)
    setCurrentStep(LoginStep.VERIFICATION)
  }

  const handleBack = () => {
    setCurrentStep(LoginStep.CREDENTIALS)
  }

  return (
    <div className={styles.wrapper}>
      <aside className={styles.brandPanel}>
        <div className={styles.brandContent}>
          <img src={LOGO_FULL_DARK_MODE} alt="Antipartido" className={styles.brandLogo} />
          <h1 className={styles.brandTitle}>{t("login.title")}</h1>
        </div>
      </aside>

      <main className={styles.formPanel}>
        <div className={styles.formContainer}>
          <div className={styles.mobileHeader}>
            <img src={mobileLogoSrc} alt="Antipartido" className={styles.mobileLogo} />
            <h1 className={styles.mobileTitle}>{t("login.title")}</h1>
          </div>

          <div className={styles.formSection}>
            <h2 className={styles.formTitle}>
              {currentStep === LoginStep.CREDENTIALS ? t("shared.step.credentials") : t("shared.step.verification")}
            </h2>

            {currentStep === LoginStep.CREDENTIALS ? (
              <CredentialsStep onComplete={handleCredentialsComplete} />
            ) : (
              <VerificationStep email={email} onBack={handleBack} />
            )}
          </div>

          <p className={styles.footer}>Antipartido &copy; {new Date().getFullYear()}</p>
        </div>
      </main>
      <div className={styles.themeToggle}>
        <Button
          type="outline"
          onClick={() => setThemeMode(themeMode === ThemeMode.LIGHT ? ThemeMode.DARK : ThemeMode.LIGHT)}
          iconLeft={themeMode === ThemeMode.LIGHT ? <SunIcon /> : <MoonIcon />}
        />
      </div>
    </div>
  )
}
